export default __webpack_public_path__ + "static/media/Transparent.ccf78f01.png";